<template>
  <b-button class="get-more-btn" @click="navToPage" v-if="displayButton()">{{ content }}</b-button>
</template>

<script>
import store from '@/store';
import { mapGetters } from 'vuex';

export default {
  name: "HighlightButton",
  props: {
    // If value is null then determine in logic below whether to navigate to Buy or Adjust page based on subscription/no subscription OR flexiplan/no flexiplan (via active product)
    extension: {
        type: String,
        default: null
    },
    content: {
        type: String,
        default: "Get More"
    }
  },
  computed: {
    ...mapGetters({
      products: "pricing/getProducts",
      subscription: "plan/getSubscription",
      account: "account/account"
    })
  },
  methods: {
    navToPage() {
        console.log('products: ' + JSON.stringify(this.products))
        console.log('subscription: ' + JSON.stringify(this.subscription))
        console.log('activeproduct: ' + JSON.stringify(this.activeproduct))
        if (this.extension == null) {
            if (this.subscription != null) {
                this.$router.push('/adjustplan')
            } else if (this.account != null && this.account.flexiplan) {
                this.$router.push('/adjustplan')
            } else {
                this.$router.push('/buysubscribe')
            }
        } else {
            this.$router.push(this.extension);
        }
    },
    displayButton() {
        const highestProduct = Math.max(...this.products.map(p => p.productid));
        console.log('highest: ' + highestProduct)
            console.log(JSON.stringify(this.account))
            console.log(JSON.stringify(this.subscription))
        if (this.subscription != null) {
            return this.subscription.product.productid < highestProduct ? true : false;
        } else if (this.account != null && this.account.flexiplan != null) {
            console.log(JSON.stringify(this.account))
            return this.account.flexiplan.product.productid < highestProduct ? true : false;
        } else {
            return true;
        }
    }
  },
  created: function() {
      store.dispatch('pricing/initialisePrices', true)
      store.dispatch("event/initialiseEventtype")
      store.dispatch('account/getAccount')
      store.dispatch("plan/initialiseSubscription")
  }
}
</script>

<style lang="scss" scoped>

.get-more-btn {
  float: right;
  border-radius: 24px;
  font-weight: bold;
  color: #FFF;
  border-radius: 16px;
  padding: 5px 2rem;
  background: linear-gradient(#a143a1, #512051);
  border: 3px solid gold;
  margin: 0 auto 1rem auto;
}

@media (max-width: 768px) {
  .get-more-btn {
    padding: 4px 4px;
  }
}

</style>